export default function CheckboxIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.96156 3.60059H17.0416C18.8972 3.60059 20.4016 5.10491 20.4016 6.96059V17.0406C20.4016 18.8963 18.8972 20.4006 17.0416 20.4006H6.96156C5.10589 20.4006 3.60156 18.8963 3.60156 17.0406V6.96059C3.60156 5.10491 5.10589 3.60059 6.96156 3.60059Z"
        stroke="#5E718D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
